<template>
  <div class="ml-2 mr-2">
    <v-text-field class="input-text-size pa-0" label="Status Codes"
    v-uppercase=globalSettingItem.conEverythingToCaps
    v-model.number="editedItem.statusCode" :rules="rules" type="number"
    :readonly='disableForReserverStatusCode'
    :tabindex="disableForReserverStatusCode ? -1 : 0" />
    <v-text-field class="input-text-size pa-0 ma-0" label="Description"
    v-uppercase=globalSettingItem.conEverythingToCaps
    v-model="editedItem.description"
    :readonly='disableForReserverStatusCode'
    :tabindex="disableForReserverStatusCode ? -1 : 0" />
    <v-checkbox class="input-text-size pa-0 ma-0" v-model="editedItem.taxesPaid"
    label="Clear this code when taxes are paid" :disabled="isAdminFunctionalFields" />
    <v-checkbox class="input-text-size pa-0 ma-0" v-model="editedItem.alertOnPayment"
    label="Alert when making payment" :disabled="isAdminFunctionalFields" />
    <v-checkbox class="input-text-size pa-0 ma-0" v-model="editedItem.rollToNextYear"
     label="Roll to next year" :disabled="isAdminFunctionalFields" />
    <v-checkbox class="input-text-size pa-0 ma-0" v-model="editedItem.adminOnly"
     label="Admin Only can add/remove" :disabled="isAdminFunctionalFields" />
    <v-checkbox class="input-text-size pa-0 ma-0" v-model="editedItem.errorOnMtgCoPayment"
     label="Error on Mtg Co Payment" :disabled="isAdminFunctionalFields" />
    <v-checkbox class="input-text-size pa-0 ma-0" v-model="editedItem.alertOnTaxRecord"
     label="Alert on tax record" :disabled="isAdminFunctionalFields" />
    <v-checkbox class="input-text-size pa-0 ma-0" v-model="editedItem.excludeFromPTW"
     label="Exclude from Personal Tax Warrants"
     hint="A tax year carrying this code is never warranted - it gets no warrant of its own
     and is left off other years' warrants. Use for bankruptcy and similar."
     persistent-hint
     :disabled="isAdminFunctionalFields" />
    <v-row class="mt-2">
      <v-col cols="6">
        <v-checkbox class="input-text-size pa-0 ma-0" v-model="editedItem.highlightTaxRecord"
         label="Highlight Tax Record" :disabled="isAdminHighlightFields" />
      </v-col>
      <v-col cols="6">
        <v-select
          class="input-text-size pa-0 ma-0"
          label="Select Color to highlight"
          :items="colorList"
          item-text="text"
          item-value="value"
          :readonly="isAdminHighlightFields"
          :tabindex="isAdminHighlightFields ? -1 : 0"
          v-model="editedItem.highlightColor" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';
import { isAuthorised } from '../../../store/auth/token';
import { authRoles } from '../../../router/roleGroups';
import { reservedStatusCode } from '../../../util/shared/tmc-global';
import GlobalToCaps from '../../../util/shared/GlobalToCaps.mixin.vue';
import SharedListAccessControlMixin from '../SharedListAccessControl.mixin';
import { getHighlightColorForStatusCode } from '../../tax/common-utils/tax-common.util';

export default {
  name: 'taxStatusCodesDialog',
  mixins: [GlobalToCaps, SharedListAccessControlMixin],
  props: {
    baseCrudKey: {
      type: String,
      default: 'taxStatusCodesList',
    },
  },
  components: {
  },
  data() {
    return {
      colorList: [...getHighlightColorForStatusCode],
    };
  },
  computed: {
    ...mapGetters('base/crud', [
      'item',
    ]),
    ...mapState({
      globalSettingItem: (state) => state.SystemConfig.globalSettingItem,
    }),
    editedItem: {
      get() {
        return this.item(this.baseCrudKey);
      },
      set(value) {
        this.setItem([this.baseCrudKey, value]);
      },
    },
    rules() {
      return [
        (v) => {
          if (v) {
            // the code must be a number
            const code = String(v);
            if (code.length > 3) return 'This code must be 3 characters';
            // only TmcSupport may create a reserved code. On an existing reserved record
            // the number is already locked, so the rule must not fire there - it would
            // invalidate the form and block edits to the options below.
            if ((v >= reservedStatusCode.min && v <= reservedStatusCode.max)
              && !this.isSuperAdmin && !this.editedItem._id) return 'These codes are reserved';
            return true;
          }
          return true;
        },
      ];
    },
    // The code number and description of an existing reserved (400-499) record are
    // locked for everyone except TmcSupport.
    disableForReserverStatusCode() {
      if (this.isSuperAdmin) return false;
      const statusCode = this.editedItem.statusCode || 0;
      if ((statusCode >= reservedStatusCode.min && statusCode <= reservedStatusCode.max)
       && this.editedItem._id) return true;
      return false;
    },
    // Every other field on a status code is editable by whoever may save the shared
    // list, reserved range included. Same gate as the Save/Add buttons in the list.
    isAdminFunctionalFields() {
      return !this.canEditSharedList;
    },
    isAdminHighlightFields() {
      return !this.canEditSharedList;
    },
    isSuperAdmin() {
      return isAuthorised(authRoles.SuperAdmin);
    },
  },
  methods: {
    ...mapMutations('base/crud', [
      'setItem',
    ]),
  },
};
</script>
